import Vue from 'vue'

// Lib imports
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
VueCookies.config('2d')

VueCookies.set('session','');
VueCookies.set('session-time','2d');

